import React from 'react';
import './select-customers.scss';
import { SVGS } from '../../assets';
import { Avatar } from '../avatar';
export const SelectCustomers = () => {
  return (
    <div className="select-customers-container">
      <div className="select-customers-container-item">
        <div className="select-customers-container-item-left">
          <img src={SVGS.RadioChecked} alt="" />
        </div>
        <Avatar title="MK Traders" />
        <div className="select-customers-container-item-right">
          <div className="select-customers-container-item-right-top font-semibold">
            MK Traders
          </div>
          <div className="select-customers-container-item-right-bottom font-regular">
            Code: 4601{' '}
            <span className="select-customers-container-item-right-bottom-dot">
              •
            </span>{' '}
            7022477834
          </div>
        </div>
      </div>
      <div className="select-customers-container-item">
        <div className="select-customers-container-item-left">
          <img src={SVGS.RadioDefault} alt="" />
        </div>
        <Avatar title="MK Traders" />
        <div className="select-customers-container-item-right">
          <div className="select-customers-container-item-right-top font-semibold">
            MK Traders
          </div>
          <div className="select-customers-container-item-right-bottom font-regular">
            Code: 4601{' '}
            <span className="select-customers-container-item-right-bottom-dot">
              •
            </span>{' '}
            7022477834
          </div>
        </div>
      </div>
    </div>
  );
};
